import { createLoader } from '@meteor/data-hooks';
import { useEffect, useState, useRef } from 'react';
import { withAuth } from '../../user';
import { organizationClient } from '../client';
import { useCurrentOrganization } from './organization';

export let configLoader = createLoader({
  name: 'config',
  fetch: (i: { organizationId: string; key: string; type: string }) =>
    withAuth(() => organizationClient.config.get(i)),
  mutators: {
    set: (i: { value: any }, { input: { organizationId, key, type } }) =>
      withAuth(() =>
        organizationClient.config.set({
          organizationId,
          type,
          key,
          ...i
        })
      )
  }
});

export let useConfig = <T extends object>(type: string, key: string) => {
  let org = useCurrentOrganization();
  let config = configLoader.use(org.data ? { organizationId: org.data.id, key, type } : null);

  let [data, setData] = useState(() => config.data?.value);
  useEffect(() => setData(config.data?.value), [config.data]);

  let updateMutator = config.useMutator('set')();
  let lastSetRef = useRef(0);

  let setConfig = (configValue: React.SetStateAction<T>) => {
    setData(v => {
      let r = typeof configValue === 'function' ? configValue(v as any) : configValue;

      if (Math.abs(Date.now() - lastSetRef.current) > 100) {
        lastSetRef.current = Date.now();
        updateMutator.mutate({ value: r });
      }

      return r as any;
    });
  };

  return [data, setConfig] as any as [T | null, React.Dispatch<React.SetStateAction<T>>];
};
